<template>
  <div class="industrydata"  id="demo">
    <div class="itemtop">
      <h3>专题专栏</h3>
       <router-link :to="`/news/views/${plateIdInfo}`"></router-link>
    </div>
     <div id="demo13" style="overflow: hidden; height: 143px; width: 100%; clear:both;">
				<table align="center" border="0" cellpadding="0" cellspacing="0" width="95%">
					<tbody>
						<tr>
							<td id="demo11" valign="middle">
								<table border="0" cellspacing="0" cellpadding="0">
									<tbody>
										<tr>
											<td v-for="(item ,index) in infos" :key="index">
                        <a >
													<div class="pic"
                          @click="$router.push(`/news/info/${item.plateid}/${item.uuid}`)"
														:style="`background-image: url(${IP_TEST}/uploads/${item.picsrc})`">
													</div>
												</a>
                      </td>
										</tr>
									</tbody>
								</table>
							</td>
							<td id="demo12" valign="top">
								<table border="0" cellspacing="0" cellpadding="0">
									<tbody>
										<tr>
										<td v-for="(item ,index) in infos" :key="index">
                        <a>
													<div class="pic"
                          @click="$router.push(`/news/info/${item.plateid}/${item.uuid}`)"
														:style="`background-image: url(${IP_TEST}/uploads/${item.picsrc})`">
													</div>
												</a>
                      </td>
                      </tr>
									</tbody>
								</table>

							</td>
						</tr>
					</tbody>
				</table>
			</div>
    <!-- <div  id="demo"> -->
    <!-- </div> -->
    
  </div>
</template>

<script>
import { IP_TEST } from '@/config'
import {getNewsViews} from '@/request/get'
export default {
  name: "Interaction",
  data(){
    return {
      infos: [],
      IP_TEST,
      plateIdInfo:''
    }
  },
  created() {
     this.changeInfo(0,'专题专栏');
  },
  mounted(){
    this.$nextTick(function(){
           function srcollpic(x, y, z) {
              var speed = 30
              var demo2 = document.getElementById(x);
              var demo1 = document.getElementById(y);
              var demo = document.getElementById(z);
              demo2.innerHTML = demo1.innerHTML;
              function Marquee() {
                // console.log("demo.scrollLeft = " + demo.scrollLeft)
                // console.log("demo1.offsetWidth = " + demo1.offsetWidth)
                // console.log("demo.offsetWidth = " + demo.offsetWidth)
                if (demo.scrollLeft == demo1.offsetWidth-demo.offsetWidth) demo.scrollLeft = demo2.offsetWidth;
                demo.scrollLeft=demo.scrollLeft+1;
              }

              var MyMar = setInterval(Marquee, speed)
              demo.onmouseover = function () { clearInterval(MyMar) }
              demo.onmouseout = function () { MyMar = setInterval(Marquee, speed) }
            }
            srcollpic('demo12', 'demo11', 'demo13')
            
        })
  },
  methods: {
   async getNewsViews(uuid) {
      let result = await getNewsViews(uuid, 1,10);
      result = result.data.concat(result.data);
      this.infos = result || [];
    },
    changeInfo(index, name) {
      this.activeInfoIndex = index
      let { plates } = this.$store.state;
      let plate = plates.filter(plate => plate.name == name);
      this.plateIdInfo = plate[0].uuid;
      this.getNewsViews(this.plateIdInfo);
    },
  }
};
</script>
<style scoped>
.industrydata {
  position: relative;
  /* margin-top: 52px; */
  width: 1300px;
  /* padding-left: 15px; */
  display: flex;
  flex-direction: column;
  justify-content: start;
  overflow: hidden;
  margin-top:24px;
  background-color: #fff;
}

.industrydata>.itemtop {
  height: 58px;
  border-bottom: 1px solid #EFF1F4;
  
  margin-bottom:20px;
  background-image: url(/static/img/title.png);
  background-repeat: no-repeat;
  background-position-y: 20px;
}
.industrydata>.itemtop>a{
 
    position: absolute;
    padding-right: 25px;
    right: 5px;
    top: 6px;
    height: 58px;
    font-size: 14px;
  
    font-weight: 500;
    color: #B2B2B2;
    line-height: 58px;
    background: url(/static/img/gengduo1.png) no-repeat 12px 12px;
    background-position: center right;
}
.industrydata>.itemtop>h3 {
  width: 102px;
    height: 55px;
  
 
  margin-left: 50px;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: #004FB7;
  line-height: 58px;
  border-bottom: 5px solid #0041BE;
  
}
.industrydata>.itemtop>h3>img{
  position: relative;
  top:14px;
}
.industrydata>.itemtop::before {
  content: '';
  position: absolute;
  top: 11px;
  left: 11px;
  width: 22px;
  height: 22px;
  background: url(/static/img/icon_fuwu.png);
  background-size: 22px 22px;
}
.industrydata>.itembottom{
  padding-left: 4px;
  height: 108px;
  display: inline-block;
  justify-content: space-between;
}
.industrydata>.itembottom>.itemone{
  width: 200px;
  height: 108px;
  /* border: 1px solid #ECECEC; */
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items:center;
}
.industrydata>.itembottom>.itemone>img{
  /* margin: 54px 0 37px; */
}
.industrydata>.itembottom>.itemone>h4{
  height: 16px;
  font-size: 16px;

  font-weight: 500;
  color: #333333;
  line-height: 16px;
}
.ggw{
  margin:auto;
	margin-bottom: 15px;
  width: 1300px;
}
.pic{
	width: 280px;
	height: 118px;
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	margin-right: 32px;
}
</style>
